import { Action } from '@ngrx/store';
import { createReducer, on } from '@ordersnproducts/utils/create-reducer';
import OrderScheduleActions from '../actions/schedule-order-confirmation.actions';

export interface ScheduleOrderConfirmationState {
  loading: boolean;
  error: any;
  groupOrderRequest: any;
}

export const initialState: ScheduleOrderConfirmationState = {
  loading: false,
  error: null,
  groupOrderRequest: null,
};

export const scheduleOrderReducer = createReducer(
  initialState,
  on(OrderScheduleActions.createSimulateOrder, (state, {}) => {
    return {
      ...state,
      loading: true,
    } as ScheduleOrderConfirmationState;
  }),

  on(OrderScheduleActions.onlyCreateOrder, (state, {}) => {
    return {
      ...state,
      loading: true,
    } as ScheduleOrderConfirmationState;
  }),

  on(OrderScheduleActions.orderConfirmationRequest, (state, { payload }) => {
    return {
      ...state,
      loading: false,
      error: null,
    } as ScheduleOrderConfirmationState;
  }),

  on(OrderScheduleActions.createSimulateOrderError, (state, { payload }) => {
    return {
      ...state,
      loading: false,
      error: payload,
    } as ScheduleOrderConfirmationState;
  }),

  on(OrderScheduleActions.onlyCreateOrderError, (state, { payload }) => {
    return {
      ...state,
      loading: false,
      error: payload,
    } as ScheduleOrderConfirmationState;
  }),

  on(OrderScheduleActions.validateGroupOrderRequestSuccess, (state, { payload }) => {
    return {
      ...state,
      groupOrderRequest: { ...state.groupOrderRequest, ...payload },
      error: null,
    } as ScheduleOrderConfirmationState;
  }),

  on(OrderScheduleActions.closeGroupOrderRequestSuccess, (state, { payload }) => {
    return {
      ...state,
      groupOrderRequest: { ...state.groupOrderRequest, ...payload },
      error: null,
    } as ScheduleOrderConfirmationState;
  }),
);

export function reducer(state: ScheduleOrderConfirmationState | undefined, action: Action) {
  return scheduleOrderReducer(state, action);
}
